import { createSlice } from "@reduxjs/toolkit";
import { setLanguageKey } from "../../utils/session";

const savedLanguage = sessionStorage.getItem("appLanguage") || "ar";

const languageSlice = createSlice({
  name: "language",
  initialState: {
    lang: savedLanguage   
  },
  reducers: {
    setLanguage: (state, action) => {
      state.lang = action.payload;
      setLanguageKey(action.payload) 
    }
  }
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
